/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetCrateDto interface.
 */
export function instanceOfGetCrateDto(value) {
    if (!('editable' in value) || value['editable'] === undefined)
        return false;
    return true;
}
export function GetCrateDtoFromJSON(json) {
    return GetCrateDtoFromJSONTyped(json, false);
}
export function GetCrateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'editable': json['editable'],
    };
}
export function GetCrateDtoToJSON(json) {
    return GetCrateDtoToJSONTyped(json, false);
}
export function GetCrateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'editable': value['editable'],
    };
}
